import { CouponType, CreateCouponNode } from '@/api/dashboard'
import { useGameItemsQuery } from '@/api/useGameItems'
import { useGenerateCompanyPath } from '@/libs'
import { useTranslation } from 'react-i18next'

export const CouponDesc = ({ node }: { node: CreateCouponNode }) => {
  const { companyId, gameId } = useGenerateCompanyPath()
  const { t } = useTranslation()
  const { data: items = [] } = useGameItemsQuery(companyId, gameId, {
    ids: node.item_id,
  })

  switch (node.type) {
    case CouponType.Bonus:
      return `${t('coupon.type.bonus')} ${node.bonus_percent}%`
    case CouponType.Discount:
      return `${t('coupon.type.discount')} ${node.discount_percent}%`

    case CouponType.FreeItem:
      let item = items.find(it => it.id == node.item_id)
      return `${t('coupon.type.free_item')} ${item?.name || ''}`
  }
  return ''
}
